import { getSessionAttendees } from '../selectors/sessionSelectors';
import { removeSessionMutator } from '../mutators/sessionMutators';
import { removeSessionForAttendees } from '../actions/removeSessionForAttendees';

/**
 * Removes a session for a consumer of the cache and clears all related data
 * @param sessionId Id for this cache session
 */
export function removeCacheSession(sessionId: string): void {
    const attendees = getSessionAttendees(sessionId);

    removeSessionForAttendees(sessionId, attendees);

    removeSessionMutator(sessionId);
}
